import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Input, Button } from "antd";
import { API_URL } from "../../config";
import AntDesignTable from "../common/antTable/AntDesignTable";
import moment from "moment";

const PastAppointmentContainer = () => {
  const [appointments, setAppointments] = useState([]);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const response = await axios.get(`${API_URL}/appointment/all/`);
      setAppointments(response.data);
      setFilteredAppointments(response.data);
    } catch (error) {
      console.error("There was an error fetching the appointment data!", error);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    const filteredData = appointments.filter((appointment) =>
      appointment.patient_name?.toLowerCase().includes(value),
    );

    setFilteredAppointments(filteredData);
  };

  const renderStatusButton = (status) => {
    let buttonProps = {};

    switch (status) {
      case "COMPLETED":
        buttonProps = {
          borderColor: "green",
          textColor: "green",
          text: "Completed",
        };
        break;
      case "MISSED":
        buttonProps = {
          borderColor: "#ff6666",
          textColor: "#ff6666",
          text: "Missed",
        };
        break;
      case "CANCELLED":
        buttonProps = {
          borderColor: "orange",
          textColor: "orange",
          text: "Cancelled",
        };
        break;
      default:
        buttonProps = {
          borderColor: "grey",
          textColor: "grey",
          text: "Unknown",
        };
    }

    return (
      <Button
        type="default"
        style={{
          width: "100px",
          borderColor: buttonProps.borderColor,
          color: buttonProps.textColor,
        }}
      >
        {buttonProps.text}
      </Button>
    );
  };

  const columns = [
    {
      title: "Type",
      dataIndex: "appointment_type",
      key: "appointment_type",
    },
    {
      title: "Patient Name",
      dataIndex: "patient_name",
      key: "patient_name",
      render: (patient_name) => patient_name || "-",
    },
    {
      title: "Doctor Name",
      key: "doctor_name",
      render: (_, record) => {
        const doctorDetails = record.doctor_details;
        if (!doctorDetails) {
          return "-";
        }
        const { salutation, first_name, last_name } = doctorDetails;
        return (
          `${salutation || ""} ${first_name || ""} ${last_name || ""}`.trim() ||
          "-"
        );
      },
    },
    {
      title: "Start Time",
      dataIndex: "start_datetime",
      key: "start_datetime",
      render: (start_datetime) =>
        start_datetime
          ? moment(start_datetime).format("YYYY-MM-DD HH:mm")
          : "-",
    },
    {
      title: "End Time",
      dataIndex: "end_datetime",
      key: "end_datetime",
      render: (end_datetime) =>
        end_datetime ? moment(end_datetime).format("YYYY-MM-DD HH:mm") : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => renderStatusButton(text),
    },
  ];

  return (
    <React.Fragment>
      <Input
        placeholder="Search by patient name"
        value={searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: 300 }}
      />
      <AntDesignTable columns={columns} tableData={filteredAppointments} />
    </React.Fragment>
  );
};

export default PastAppointmentContainer;
